import { Button, Flex, FormControl, FormLabel, Input } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteUser } from "../../redux/thunks/userThunks";
import { redResetDeletedUser, redSetToast } from "../../redux/slices/userSlice";
import Toasts from "../Toasts";

const DeleteUser = () => {
  const dispatch = useDispatch();
  const [deleteEmail, setDeleteEmail] = useState("");

  const { deletedUser, loading } = useSelector(
    (state) => state.stateUserReducer
  );

  useEffect(() => {
    if (deletedUser) {
      dispatch(
        redSetToast({ title: "User succesfully deleted", status: "success" })
      );
      dispatch(redResetDeletedUser());
    }
  }, [deletedUser]);

  return (
    <>
      <Toasts />
      <Flex
        as="main"
        justify="center"
        bg="gray.200"
        align="center"
        w="100%"
        h="100%"
      >
        <Flex
          w="97%"
          h="95%"
          borderRadius="20px"
          p={4}
          bg="white"
          px="20px"
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Flex
            bgColor="white"
            p={5}
            minW="22rem"
            direction="column"
            borderRadius={10}
            border="1px solid black"
          >
            <FormControl>
              <FormLabel color="black">Enter Email</FormLabel>
              <Input
                placeholder="Enter email"
                borderColor="gray"
                color="black"
                _placeholder="Enter email"
                onChange={(e) => setDeleteEmail(e.target.value.trim())}
              ></Input>
            </FormControl>
            <Button
              colorScheme="red"
              mt={5}
              onClick={() => dispatch(deleteUser(deleteEmail))}
              isLoading={loading}
            >
              Delete User
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};

export default DeleteUser;
